function closeAddedToCartModal(modalRefWrapper) {
  if (modalRefWrapper.ref) {
    modalRefWrapper.ref.classList.add("closing");
  }

  setTimeout(() => {
    closeModal();
  }, 2000);
}

function openAddedToCartModal(variant) {
  const ADDED_TO_CART_MODAL_VISIBLE_SECONDS = 3;
  const ADDED_TO_CART_MODEL_WIDTH = "320px";
  const ADDED_TO_CART_MODEL_HEIGHT = "210px";

  const modalRefWrapper = {
    ref: null,
  };
  const closeTimeout = setTimeout(() => {
    closeAddedToCartModal(modalRefWrapper);
  }, ADDED_TO_CART_MODAL_VISIBLE_SECONDS * 1000);

  const reference = openModal(
    ADDED_TO_CART_MODEL_WIDTH,
    ADDED_TO_CART_MODEL_HEIGHT,
    () => clearTimeout(timeout),
    false,
  );

  modalRefWrapper.ref = reference;

  reference.classList.add("top-right");
  reference.classList.add("added-to-cart-modal");
  reference.classList.add("d-flex", "flex-column", "p-3");

  const title = document.createElement("span");
  title.innerText = "Item Added to Basket";
  title.classList.add("user-select-none");

  const addedProduct = document.createElement("div");
  addedProduct.classList.add(
    "w-100",
    "d-flex",
    "flex-row",
    "gap-2",
    "justify-content-between",
    "mt-4",
  );

  const productImg = document.createElement("img");
  const imageUrl = variant.featured_image.url;
  const optimizedImageUrl = imageUrl + (imageUrl.includes("?") ? "&" : "?") + "width=100";
  productImg.src = optimizedImageUrl;
  productImg.classList.add("added-product-image");
  productImg.fetchPriority = "high";
  productImg.decoding = "async";
  addedProduct.appendChild(productImg);

  const productInfo = document.createElement("div");
  productInfo.classList.add("d-flex", "flex-column", "added-product-info");
  addedProduct.appendChild(productInfo);

  const productTitle = document.createElement("h6");
  productTitle.classList.add("text-black");
  productTitle.innerText = variant.product_title;
  productInfo.appendChild(productTitle);

  const productSubtitle = document.createElement("small");
  productSubtitle.innerText = variant.variant_title;
  productSubtitle.classList.add("text-darker-secondary");
  productInfo.appendChild(productSubtitle);

  const viewCartButton = document.createElement("a");
  viewCartButton.classList.add("w-100", "mt-4", "important-btn");
  viewCartButton.innerText = "View Basket";
  viewCartButton.href = window.Shopify.routes.root + "cart";

  reference.appendChild(title);
  reference.appendChild(addedProduct);
  reference.appendChild(viewCartButton);
}
